// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__10Nrm","errorLogs":"EditorFooter_errorLogs__20k65"};